








































































































import IssueVote from './scripts';
export default IssueVote;
